import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "../contexts/AuthContext";
import appLogo from "../../../assets/app-logo.png";

export const UpdatePassword: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { updatePassword } = useAuth();

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [isUpdating, setIsUpdating] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);

    if (password !== confirmPassword) {
      setError("Las contraseñas no coinciden");
      return;
    }

    if (password.length < 6) {
      setError("La contraseña debe tener al menos 6 caracteres");
      return;
    }

    setIsUpdating(true);
    const res = await updatePassword(password);
    setIsUpdating(false);

    if (res.success) {
      // Navigate to home/projects after successful update
      navigate("/", { replace: true });
    } else {
      setError(res.error || "No se pudo actualizar la contraseña");
    }
  };

  return (
    <div
      style={{
        height: "100vh",
        width: "100vw",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        background: "#000",
        fontFamily: "var(--font-family)",
      }}
    >
      <div style={{ textAlign: "center", marginBottom: "40px" }}>
        <img src={appLogo} alt="Braindog" style={{ height: "110px", marginBottom: "30px" }} />
      </div>

      <div
        style={{
          background: "rgba(30, 30, 30, 0.95)",
          padding: "40px",
          borderRadius: "12px",
          border: "1px solid var(--color-panel-border)",
          width: "400px",
          boxShadow: "0 10px 40px rgba(0,0,0,0.5)",
          display: "flex",
          flexDirection: "column",
          gap: "20px",
        }}
      >
        <h3
          style={{
            margin: 0,
            color: "var(--color-text-primary)",
            textAlign: "center",
            marginBottom: "5px",
            letterSpacing: "2px",
            fontSize: "1rem",
          }}
        >
          NUEVA CONTRASEÑA
        </h3>

        <p
          style={{
            color: "var(--color-text-muted)",
            fontSize: "0.85rem",
            textAlign: "center",
            margin: 0,
          }}
        >
          Por favor, ingresa tu nueva contraseña para acceder a la plataforma.
        </p>

        {error && (
          <div
            style={{
              color: "#ff4444",
              background: "rgba(255,0,0,0.1)",
              padding: "10px",
              borderRadius: "8px",
              fontSize: "0.85rem",
              textAlign: "center",
            }}
          >
            {error}
          </div>
        )}

        <form
          onSubmit={handleSubmit}
          style={{ display: "flex", flexDirection: "column", gap: "15px" }}
        >
          <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
            <label
              style={{
                color: "var(--color-text-muted)",
                fontSize: "0.7rem",
                fontWeight: 600,
                letterSpacing: "0.5px",
              }}
            >
              NUEVA CONTRASEÑA
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              style={{
                background: "#111",
                border: "1px solid #333",
                padding: "12px",
                borderRadius: "6px",
                color: "#fff",
                outline: "none",
                fontSize: "0.95rem",
              }}
            />
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
            <label
              style={{
                color: "var(--color-text-muted)",
                fontSize: "0.7rem",
                fontWeight: 600,
                letterSpacing: "0.5px",
              }}
            >
              CONFIRMAR CONTRASEÑA
            </label>
            <input
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              style={{
                background: "#111",
                border: "1px solid #333",
                padding: "12px",
                borderRadius: "6px",
                color: "#fff",
                outline: "none",
                fontSize: "0.95rem",
              }}
            />
          </div>
          <button
            type="submit"
            disabled={isUpdating}
            style={{
              marginTop: "5px",
              background: "var(--color-accent-primary)",
              color: "#fff",
              border: "none",
              padding: "14px",
              borderRadius: "6px",
              fontSize: "0.95rem",
              fontWeight: 700,
              cursor: isUpdating ? "wait" : "pointer",
              opacity: isUpdating ? 0.7 : 1,
              transition: "all 0.2s",
            }}
          >
            {isUpdating ? "Actualizando..." : "Guardar Contraseña"}
          </button>
        </form>
      </div>
    </div>
  );
};
